<template>
  <svg :width="size ? size.width : 16" :height="size ? size.height : 14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 1C0 0.447715 0.447716 0 1 0H15C15.5523 0 16 0.447715 16 1V3C16 3.55228 15.5523 4 15 4V11.5C15 12.8807 13.8807 14 12.5 14H3.5C2.11929 14 1 12.8807 1 11.5V4C0.447715 4 0 3.55228 0 3V1ZM2 4V11.5C2 12.3284 2.67157 13 3.5 13H12.5C13.3284 13 14 12.3284 14 11.5V4H2ZM15 1H1V3H15V1ZM5 6.5C5 6.22386 5.22386 6 5.5 6H10.5C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7H5.5C5.22386 7 5 6.77614 5 6.5Z" fill="#044389"/>
</svg>
  </template>
<script>
export default {
  props:['size']
}
</script>